// Utility to manage motivational quotes

const QUOTE_STORAGE_KEY = 'motivationalQuoteSettings';

// Default settings
const defaultSettings = {
  showOnLogin: true,
  lastShownDate: null,
  dismissedToday: false
};

const getQuoteSettings = () => {
  try {
    const settings = localStorage.getItem(QUOTE_STORAGE_KEY);
    return settings ? JSON.parse(settings) : defaultSettings;
  } catch (error) {
    console.error('Error reading quote settings:', error);
    return defaultSettings;
  }
};

const saveQuoteSettings = (settings) => {
  try {
    localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving quote settings:', error);
  }
};

export const shouldShowModalOnLogin = () => {
  const settings = getQuoteSettings();
  const today = new Date().toDateString();
  
  // Reset dismissedToday if it's a new day
  if (settings.lastShownDate !== today) {
    settings.dismissedToday = false;
    saveQuoteSettings(settings);
  }
  
  // Don't show if user disabled it or already dismissed today
  if (!settings.showOnLogin || settings.dismissedToday) {
    return false;
  }
  
  // Show the quote (it's a new session and hasn't been shown today)
  return true;
};

export const markQuoteAsShown = () => {
  const settings = getQuoteSettings();
  const today = new Date().toDateString();
  
  settings.lastShownDate = today;
  settings.dismissedToday = true;
  
  saveQuoteSettings(settings);
  
  // Reset dismissedToday at midnight
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const timeUntilMidnight = midnight - now;
  
  setTimeout(() => {
    const currentSettings = getQuoteSettings();
    currentSettings.dismissedToday = false;
    saveQuoteSettings(currentSettings);
  }, timeUntilMidnight);
};